{
  "zh-TW": {
    "nav": {
      "locations": "地點",
      "home": "首頁",
      "back": "返回",
      "navigation": "導航",
      "ships": {
        "index": "飛船"
      },
      "compare": {
        "index": "比較",
        "ships": "比較飛船"
      },
      "manufacturers": "製造商",
      "images": "圖片",
      "videos": "影片",
      "shipHistory": "歷史",
      "componentHistory": "歷史",
      "hangar": {
        "index": "我的機庫",
        "vehicleLoadouts": "Loadouts",
        "inventories": "Inventories",
        "vehicleCargo": "貨物",
        "buybacks": "回購",
        "imports": "匯入記錄",
        "transfers": "轉移"
      },
      "login": "登入",
      "installApp": "安裝應用程式",
      "logout": "登出",
      "apiV1": "API v1",
      "apiV1Schema": "架構",
      "apiV1Pagination": "分頁",
      "authApiV1": "Auth API v1",
      "authApiV1OpenId": "OpenID Connect",
      "authApiV1Schema": "架構",
      "embed": "嵌入小工具",
      "signUp": "註冊",
      "privacyPolicy": "隱私政策",
      "impressum": "法律聲明",
      "fleets": {
        "index": "艦隊",
        "add": "建立新艦隊",
        "invites": "邀請",
        "ships": "飛船",
        "blueprints": "藍圖",
        "assets": "資產",
        "members": {
          "index": "Members",
          "invites": "Invites",
          "worldmap": "世界地圖",
          "starmap": "星圖"
        },
        "squadrons": {
          "index": "中隊",
          "overview": "總覽",
          "members": "成員",
          "create": {
            "details": "詳細資訊",
            "appearance": "外觀",
            "discord": "Discord"
          },
          "edit": {
            "details": "詳細資訊",
            "appearance": "外觀",
            "discord": "Discord"
          }
        },
        "stats": "統計",
        "logistics": {
          "index": "Logistics"
        },
        "missions": {
          "index": "任務",
          "edit": {
            "details": "詳細資訊",
            "teams": "小隊與席位"
          }
        },
        "events": {
          "index": "活動",
          "calendar": "行事曆",
          "edit": {
            "details": "詳細資訊",
            "schedule": "時間安排",
            "signup": "報名",
            "teams": "小隊與席位"
          },
          "payouts": "分帳"
        },
        "tours": "行程",
        "settings": {
          "index": "設定",
          "fleet": "艦隊設定",
          "rsi": "艦隊 ID 與 RSI",
          "membership": "成員設定",
          "roles": "角色",
          "squadrons": "中隊",
          "allies": "盟友",
          "notifications": "通知",
          "discord": "Discord",
          "calendar": "行事曆",
          "features": "功能",
          "contracts": "合約"
        },
        "contracts": {
          "index": "合約",
          "payouts": "分帳"
        },
        "directory": "目錄"
      },
      "rsiProfile": "RSI 檔案",
      "rsiHangar": "RSI 機庫",
      "tools": {
        "index": "工具",
        "travelTimes": "旅行時間",
        "cargoGrids": "貨物網格",
        "tradeRoutes": "貿易路線",
        "tours": "行程"
      },
      "api": "API 文件",
      "stats": "統計",
      "toggleSlimCollapse": "摺疊",
      "toggleSlimExpand": "展開",
      "roadmap": {
        "index": "路線圖",
        "overview": "概覽",
        "changes": "變更",
        "ships": "飛船路線圖"
      },
      "rsiVerification": "RSI 驗證",
      "settings": {
        "index": "設定",
        "profile": "檔案",
        "account": "帳戶",
        "security": "安全",
        "notifications": "通知",
        "calendar": "行事曆",
        "donations": "捐贈",
        "hangar": "機庫",
        "privacy": "隱私",
        "features": "功能",
        "connections": "連線",
        "oauthApplications": "OAuth 應用",
        "verify": "RSI 帳戶驗證",
        "friends": "好友"
      },
      "reload": "有可用更新！",
      "visualTests": {
        "blueprints": "藍圖",
        "index": "視覺測試",
        "panels": "面板",
        "buttons": "按鈕",
        "events": "活動",
        "typography": "排版",
        "forms": "表單",
        "tables": "表格",
        "lists": "列表",
        "metrics": "指標",
        "states": "狀態",
        "notifications": "通知",
        "syncModal": "同步彈窗",
        "overlays": "覆蓋層",
        "installPrompt": "安裝提示",
        "supportHint": "支援提示",
        "media": "媒體",
        "charts": "圖表",
        "alerts": "提示",
        "verifiedBadges": "驗證徽章",
        "chips": "Chips",
        "squadrons": "中隊",
        "groups": {
          "foundations": "基礎",
          "data": "資料",
          "feedback": "回饋",
          "features": "功能"
        },
        "notificationCenter": "通知中心",
        "themes": "主題"
      },
      "admin": {
        "features": {
          "overview": "概覽",
          "users": "使用者",
          "fleets": "艦隊",
          "history": "歷史"
        },
        "locations": {
          "index": "地點"
        },
        "blueprints": {
          "index": "藍圖"
        },
        "missions": {
          "index": "任務"
        },
        "index": "管理員",
        "models": {
          "index": "模型",
          "create": "建立模型",
          "edit": {
            "index": "基礎資料",
            "metrics": "指標",
            "prices": "價格",
            "docks": "停靠點",
            "modules": "模組",
            "paints": "塗裝",
            "images": "圖片",
            "videos": "影片",
            "cargoAndFuel": "貨物和燃料",
            "cargoHolds": "貨艙",
            "fleetchart": "艦隊圖表圖片",
            "positions": "乘員位置",
            "hardpoints": "掛載點",
            "loaners": "借用船",
            "snubCrafts": "艦載小艇",
            "upgrades": "升級",
            "packages": "套餐",
            "history": "歷史"
          }
        },
        "modelPaints": {
          "index": "塗裝",
          "create": "建立塗裝"
        },
        "modelModules": {
          "index": "模組",
          "create": "建立模組",
          "edit": {
            "index": "基本資料",
            "models": "模型",
            "prices": "價格",
            "hardpoints": "武器掛點",
            "docks": "停靠點",
            "cargoHolds": "貨艙",
            "history": "歷史"
          }
        },
        "unlistedModels": {
          "index": "未收錄的飛船"
        },
        "modelModulePackages": {
          "index": "模組包",
          "create": "建立模組包"
        },
        "components": {
          "index": "組件",
          "edit": {
            "index": "基礎資料",
            "prices": "價格",
            "history": "歷史"
          }
        },
        "manufacturers": {
          "index": "製造商",
          "edit": {
            "index": "基礎資料",
            "models": "飛船",
            "components": "元件",
            "equipment": "裝備",
            "modules": "模組"
          }
        },
        "images": {
          "index": "圖片"
        },
        "users": {
          "index": "使用者",
          "edit": "編輯",
          "fleets": "艦隊",
          "inventories": "庫存",
          "supporterContributions": "貢獻"
        },
        "fleets": {
          "index": "艦隊",
          "edit": "編輯",
          "members": "成員",
          "history": "歷史",
          "roles": "角色",
          "inventories": "庫存"
        },
        "fleetFidClaims": {
          "index": "FID 申領"
        },
        "destroyedFleets": {
          "index": "已刪除艦隊"
        },
        "vehicles": {
          "index": "載具"
        },
        "admins": {
          "index": "管理員"
        },
        "oauthApplications": {
          "index": "OAuth 應用"
        },
        "maintenance": {
          "index": "維護",
          "pghero": "PG-Hero",
          "features": "功能",
          "workers": "工作程序",
          "tasks": "任務",
          "imports": "匯入",
          "rsiApiStatus": "RSI API 狀態",
          "buildCompare": "版本比較"
        },
        "announcements": {
          "index": "公告",
          "new": "新增公告",
          "edit": "編輯公告"
        },
        "supporterContributions": {
          "index": "支持者貢獻",
          "new": "新增支持者貢獻",
          "edit": "編輯支持者貢獻"
        },
        "fundingGoals": {
          "index": "資金目標",
          "new": "新增資金目標",
          "edit": "編輯資金目標"
        },
        "notifications": {
          "index": "通知"
        },
        "commodities": {
          "index": "Commodities",
          "edit": {
            "index": "Base Data"
          }
        },
        "equipment": {
          "index": "Equipment",
          "edit": {
            "index": "Base Data",
            "prices": "Prices"
          }
        },
        "visualTests": {
          "index": "視覺測試",
          "notifications": "通知"
        },
        "groups": {
          "catalogue": "目錄",
          "community": "社群",
          "people": "人員",
          "system": "系統"
        }
      },
      "notifications": "通知",
      "scDataSource": "資料來源",
      "commodities": {
        "index": "商品"
      },
      "components": {
        "index": "部件"
      },
      "catalogue": {
        "commodities": "商品",
        "index": "目錄",
        "components": "部件",
        "blueprints": "藍圖",
        "missions": "任務",
        "equipment": "裝備"
      },
      "equipment": {
        "index": "裝備"
      }
    }
  }
}
